import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function getDashboardJobDetailed(
  params: openapi.PortalDetailedJobQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PortalDetailedJobContentOpenapi> {
  return await api.get<openapi.PortalDetailedJobContentOpenapi>(
    '/dashboard/job/detailed/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getDashboardCustomer(
  params: openapi.CustomerDetailQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.CustomerDetailContentOpenapi> {
  return await api.get<openapi.CustomerDetailContentOpenapi>(
    '/dashboard/customer/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getDashboardJobDetailedByRhId(
  params: openapi.GetDashboardJobDetailedByRhId_Query,
  path: openapi.GetDashboardJobDetailedByRhId_Path,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetDashboardJobDetailedByRhId_200> {
  return await api.get<openapi.GetDashboardJobDetailedByRhId_200>(
    `/dashboard/job/detailed/${path.rh_id}/`,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getDashboardTracking(
  params: openapi.DashboardJobsTrackingQueryOpenapi,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.DashboardJobsTrackingContentOpenapi> {
  return await api.get<openapi.DashboardJobsTrackingContentOpenapi>(
    '/dashboard/tracking/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getDashboardBookingUserLog(
  params: openapi.GetDashboardBookingUserLog_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetDashboardBookingUserLog_200> {
  return await api.get<openapi.GetDashboardBookingUserLog_200>(
    '/dashboard/booking/user_log/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getDashboardBookingCustomerLog(
  params: openapi.GetDashboardBookingCustomerLog_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetDashboardBookingCustomerLog_200> {
  return await api.get<openapi.GetDashboardBookingCustomerLog_200>(
    '/dashboard/booking/customer_log/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getDashboardBookingLogOriginalData(
  params: openapi.GetDashboardBookingLogOriginalData_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<unknown> {
  return await api.get<unknown>('/dashboard/booking/log_original_data/', {
    ...requestConfig,
    params,
  });
}
